import { render, staticRenderFns } from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=template&id=6936baf6&scoped=true&lang=pug"
import script from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=script&lang=js"
export * from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=style&index=0&id=6936baf6&prod&lang=scss&scoped=true"
import style1 from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=style&index=1&id=6936baf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936baf6",
  null
  
)

export default component.exports